import { Controller } from '@hotwired/stimulus';
import copyToClipboard from 'copy-to-clipboard';

const SUCCESS_DURATION_MS = 2000;

// Copies the source target's text and shows the success label on the button for a moment
export default class extends Controller {
    static targets = ['source', 'label'];

    copy({ params: { successLabel } }) {
        copyToClipboard(this.sourceTarget.textContent.trim());

        const button = this.labelTarget;
        this.originalHtml ??= button.innerHTML;
        button.textContent = successLabel;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            button.innerHTML = this.originalHtml;
        }, SUCCESS_DURATION_MS);
    }

    disconnect() {
        clearTimeout(this.timeout);
    }
}
